export default __webpack_public_path__ + "static/media/Multiselect_Check_Icon.561a5149.svg";